<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="avatar mx-4">
    <v-row align="center">
      <v-col cols="auto" class="mr-5" @click="displayProfileModal">
        <v-row align="center">
          <v-col>
            <v-row dense>
              <v-icon>mdi-account-circle-outline</v-icon>
            </v-row>
          </v-col>
          <v-col cols="auto">
            <v-row>
              <span class="avatar text name">
                {{ getCurrentUserName }}
              </span>
            </v-row>
            <v-row>
              <span v-if="getCurrentUserRole" class="avatar text role">
                {{ getCurrentUserRole.displayName || '' }}
              </span>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row dense @click="userManager.logout()">
          <v-icon :title="$t('profile.buttons.signout')">mdi-logout</v-icon>
        </v-row>
      </v-col>
    </v-row>
    <UserProfile :enabled="showProfile" @close="displayProfileModal" />
  </div>
</template>

<script setup lang="ts">
import userManager from '@/auth';
import { computed, ref } from 'vue';
import useStore from '@/utils/store/common';
import UserProfile from './components/UserProfile.vue';

const store = useStore();
const showProfile = ref(false);
const getCurrentUserName = computed(() => store.getters['user/getCurrentUserName']);
const getCurrentUserRole = computed(() => store.getters['permissions/getCurrentUserRole']);

function displayProfileModal() {
  showProfile.value = !showProfile.value;
}
</script>

<style lang="scss" scoped>
@import './styles/avatar.scss';
</style>
